import mdcApp from './mdc-app.vue'
export const MdcAppComponents = {
  mdcApp,
}